import { createSlice, type PayloadAction } from "@reduxjs/toolkit";
import { type Mode } from "../components/shared/darkModeToggle";
import {
  type ColorPalette,
  getSkinConfigByUnivers,
  type SkinConfig,
} from "../styles/skin";
import { STORAGE_KEYS } from "../utils/defines";

export type NotificationConfig = {
  type: 'success' | 'error' | 'info' | 'warning';
  message: string;
  description?: string;
  duration?: number;
  timeout?: any;
};

export interface ComponentsState {
  popupsCount: number;
  skinConfig: SkinConfig;
  mode?: Mode;
  notification: NotificationConfig[];
  loader: boolean;
  //lang?: string;
}

const initialState: ComponentsState = {
  popupsCount: 0,
  skinConfig: getSkinConfigByUnivers(""),
  mode: localStorage.getItem(STORAGE_KEYS.Mode) as Mode,
  notification: [],
  loader: false
};

export const componentsSlice = createSlice({
  name: "components",
  initialState,
  reducers: {
    setColorTheme(state, payload: PayloadAction<ColorPalette>) {
      state.skinConfig.colorPalette = payload.payload;
    },
    setSkinConfig(state, payload: PayloadAction<SkinConfig>) {
      state.skinConfig = payload.payload;
    },
    setMode(state, payload: PayloadAction<Mode>) {
      state.mode = payload.payload;
      localStorage.setItem(STORAGE_KEYS.Mode, state.mode);
    },
    addNotification(state, payload: PayloadAction<NotificationConfig>) {
      state.notification = [...state.notification, payload.payload];
    },
    clearNotifications(state) {
      state.notification = [];
    },
    showLoader(state) {
      state.loader = true;
    },
    hideLoader(state) {
      state.loader = false;
    },
  },
});

export const { setColorTheme, setSkinConfig, setMode, addNotification, clearNotifications, showLoader, hideLoader } =
  componentsSlice.actions;
export const componentsReducer = componentsSlice.reducer;
